export const VIEWPORT_PADDING = 25;

export enum TOAST_TYPE_DESCRIPTION {
  TRIP_SUCCESS = 'TRIP_SUCCESS',
}
